import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

export const Footer = () => {
   const {t} = useTranslation();

   return (
      <>
         <Box sx={{mt: '1rem', width: '100%'}}>
            <a
               href="https://www.coviantsoftware.com/?utm_source=webclientn"
               target="_blank"
               rel="noreferrer"
            >
               <Typography align="center" variant="subtitle1" color="primary">
                  {t('Powered by Diplomat MFT (C) Coviant Software')}
               </Typography>
            </a>
         </Box>
      </>
   );
};
